export const getTabs = (PR: number = null, isV2: boolean) => {
    const tabs = [
        { id: 'Lines', label: 'Lines' },
        { id: 'ProductReceiptDetails', label: 'Receipt Details', disabled: !PR },
        { id: 'FreightChargeDetails', label: 'Freight Charge Details', disabled: !PR }
    ];

    // If isV2 is true, remove the 'ProductReceiptDetails' tab

    if (isV2) tabs.splice(1, 1);

    return tabs;
};

export const ProductReceiptsCalculationFields = ['OrderedQuantity', 'BackorderedQuantity', 'BuyingUnit', 'Price', 'BasePrice', 'Discount'];
export const ProductReceiptDetailsCalculationFields = ['Supplier', 'OrderType', 'ProductReceiptCategory', 'EarliestDueDate'];
export const ProductReceiptsDeliveryCalculationFields = ['SiteCode', 'FreightCode', 'Warehouse'];
export const DisabledSearchLookUpDrawerTabs = ['LineDetails', 'Commit', 'PurchaseOrderLineCommitments'];
export const DisabledChangeStatus = ['LineDetails', 'Commit', 'PurchaseOrderLineCommitments', 'PurchaseOrdersDiary', 'PurchaseOrdersDiaryDetails', 'PurchaseOrdersNotepad'];
